import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SDiContact } from '../models/sdi-contact.model';
import { environment } from '../../../environments/environment';

export interface ListSDiContactsParams {
  page?: number;
  per_page?: number;
  search?: string;
}

export interface ListSDiContactsResponse {
  data: SDiContact[];
  links: {
    first: string;
    last: string;
    prev: string | null;
    next: string | null;
  };
  meta: {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
  };
}

@Injectable({ providedIn: 'root' })
export class SDiContactsService {
  private readonly http = inject(HttpClient);

  list(params?: ListSDiContactsParams): Observable<ListSDiContactsResponse> {
    return this.http.get<ListSDiContactsResponse>(`${environment.apiUrl}/sdi-contacts`, {
      params: params as Record<string, string | number | boolean>,
    });
  }

  getById(id: string): Observable<{ data: SDiContact }> {
    return this.http.get<{ data: SDiContact }>(`${environment.apiUrl}/sdi-contacts/${id}`);
  }

  create(data: Partial<SDiContact>): Observable<{ data: SDiContact }> {
    return this.http.post<{ data: SDiContact }>(`${environment.apiUrl}/sdi-contacts`, data);
  }

  update(id: string, data: Partial<SDiContact>): Observable<{ data: SDiContact }> {
    return this.http.patch<{ data: SDiContact }>(`${environment.apiUrl}/sdi-contacts/${id}`, data);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/sdi-contacts/${id}`);
  }
}
